// extracted by mini-css-extract-plugin
export default {"root":"zE1XQ","mobile":"zDUw_"};